import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import Breadcrumbs from "../../../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import BackBtn from "../../../../../components/Common/backBtn";
import InputRadioField from "../../../../../components/Common/inputRadioField";
import InputTextField from "../../../../../components/Common/inputTextField";
import SucessModal from "../../../../../components/Modal/SucessModal";

const EducationForm = ({ edit = false, view = false }) => {
  const { id } = useParams();
  const {
    register,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useForm();

  const [success, setSuccess] = useState(false);

  const getMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}ug-degree/get/${id}`)
      .then((response) => {
        setValue("active", response.data.active);
        setValue("ug_degree", response.data.ug_degree);
        trigger();
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  useEffect(() => {
    (edit || view) && getMenuData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit]);

  const onSubmit = (fields) => {
    if (edit) {
      axios
        .patch(`${process.env.REACT_APP_API_URL}ug-degree/update/${id}`, fields)
        .then((response) => {
          if (response.data?._id) {
            setSuccess(true);
          } else {
            alert("Fail");
            console.log("failed...");
          }
        });
    } else {
      axios
        .post(`${process.env.REACT_APP_API_URL}ug-degree/create`, fields)
        .then((response) => {
          if (response.data?._id) {
            setSuccess(true);
          } else {
            alert("Fail");
            console.log("failed...");
          }
        });
    }
  };

  const breadcrumbsList = useMemo(
    () => [
      { text: "Masters", link: "/master-primary-specialisation" },
      { text: "Doctors", link: "/master-gender" },
      { text: "UG Degree", link: "/master-ug-course" },
      {
        text: edit
          ? "Edit UG Degree"
          : view
            ? "View UG Degree"
            : "Add New UG Degree",
        link: "",
      },
    ],
    [],
  );

  return (
    <>
      <Breadcrumbs
        className="w-75 healthsyMasterBreadCrumbs"
        breadcrumbsList={breadcrumbsList}
      />
      <BackBtn navigatePath="/master-ug-course" />
      <div className="healtharticle mt-5">
        <div className="pt-3 ms-3">
          {/* <Breadcrumbs
                        breadcrumbText="Master"
                        breadcrumbLink=""
                        nestedText="Doctors"
                        nestedLink=""
                        nestedText2="UG Degree"
                        nestedLink2=""
                        nestedText3={edit ? "Edit UG Degree" : "Add New UG Degree"}
                        nestedLink3=""
                    /> */}
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
          <div className="row car-dep-form">
            <div className="col-5">
              <InputTextField
                register={register}
                errors={errors}
                labelName="UG Degree"
                errorText="Please enter the degree"
                name="ug_degree"
                placeholder="Type here..."
                view={view}
              />
            </div>

            <div className="col-3">
              <InputRadioField
                register={register}
                errors={errors}
                setValue={setValue}
                watch={watch}
                disabled={view}
              />
            </div>
          </div>

          {!view && (
            <div className="car-dep-form-button">
              <button type="submit" style={{ marginTop: "5%", border: "none" }}>
                SUBMIT
              </button>
            </div>
          )}
        </form>
      </div>
      {/* </Home> */}
      {success && (
        <SucessModal
          page={"/master-ug-course"}
          name="new UG Degree"
          post={edit ? "updated" : "added"}
        />
      )}
    </>
  );
};

export default EducationForm;
